export default "__VITE_ASSET__eec63e24__"